import { createSelector } from 'utils/app.util';

export const selectCorrosionMeasureTools = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'corrosionMeasureTools']),
  (corrosionMeasureTools) => corrosionMeasureTools,
);

export const selectServiceProvider = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'serviceProviders']),
  (corrosionMeasureTools) => corrosionMeasureTools,
);

export const selectNewServiceProvider = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'newServiceProvider']),
  (newServiceProvider) => newServiceProvider,
);

export const selectNewCorrosionMeasureTool = createSelector(
  (state) =>
    state.getIn(['entity', 'corrosionLogs', 'newCorrosionMeasureTool']),
  (newCorrosionMeasureTool) => newCorrosionMeasureTool,
);

export const selectCorrosionLogsList = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'corrosionLogsList']),
  (corrosionLogsList) => corrosionLogsList,
);

export const selectCorrosionLogsFilters = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'corrosionLogsFilters']),
  (corrosionLogsFilters) => corrosionLogsFilters,
);

export const selectCompareFilesData = createSelector(
  (state) => state.getIn(['entity', 'corrosionLogs', 'compareFilesData']),
  (compareFilesData) => compareFilesData,
);
